import { useMemo } from "react";
import { useActionChoices } from "stores";
import { FormSelectInput } from "form";
import { actionInputName } from "components/action-modal/utils/inputName";
import { TASK_INPUT_NAMES } from "constants/action-form";
import { OPERATIONS, TASKS } from "constants/actions";
import { useActionModalGetContext } from "context/ActionModalProvider";
import { useTranslation } from "react-i18next";

const DISABLED_BULK_OPERATIONS = [
  OPERATIONS.DIAGNOSE.SOIL_SAMPLING,
  OPERATIONS.DIAGNOSE.LEAF_ANALYSIS,
  OPERATIONS.DIAGNOSE.INSECT_MONITORING,
];

const DiagnoseOperationInput = ({
  helperText,
  isProposed,
  isViewMode,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const { actions, getOperationById } = useActionChoices();
  const { isBulk } = useActionModalGetContext();

  const task = TASKS.diagnose;
  const taskInputName = TASK_INPUT_NAMES[task];

  const options = useMemo(() => {
    let diagnoseOptions = [];
    if (isBulk) {
      diagnoseOptions = actions.diagnose?.operations.map((op) => {
        const opName = getOperationById(op.operationTypeId);
        const shouldBeDisabled = DISABLED_BULK_OPERATIONS.includes(opName);

        return {
          value: op.operationTypeId,
          label: op.operationTypeName,
          disabled: shouldBeDisabled,
        };
      });
    } else {
      diagnoseOptions = actions.diagnose?.operations.map((op) => ({
        value: op.operationTypeId,
        label: op.operationTypeName,
      }));
    }
    const sorted = diagnoseOptions.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" }),
    );
    return sorted;
  }, [actions, getOperationById, isBulk]);

  return (
    <FormSelectInput
      name={actionInputName(taskInputName, "operationTypeId", isProposed)}
      placeholder={t("OperationInput.Diagnose.Placeholder")}
      helperText={helperText}
      shouldHaveErrorBehaviorAfterSubmit
      isDisabled={isDisabled}
      isViewMode={isViewMode}
      options={options}
    />
  );
};

export default DiagnoseOperationInput;
